import React from 'react';

import { Button, Select } from '@infoods/lifebase-ui';

import classes from './FiltersRow.module.scss';
import { addAllOption } from '../../../../shared/utils/arrayUtils';
import { platformFilterOptions } from '../../../constants/releasePlatform';
import { statusFilterOptions } from '../../../constants/releaseStatus';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { ReleaseFilterValues } from '../../../interfaces/ReleaseFilters';

type FiltersRowProps = {
  filters: ReleaseFilterValues;
  onFiltersChange: (filters: ReleaseFilterValues) => void;
  onReset: () => void;
};

const platformFilterOptionsWithAll = addAllOption(platformFilterOptions);
const statusFilterOptionsWithAll = addAllOption(statusFilterOptions);

const FiltersRow = ({ filters, onFiltersChange, onReset }: FiltersRowProps) => {
  const inputGeneralProps = { variant: 'outlined', size: 'small' } as const;

  return (
    <GridTableRow variant="filter">
      <Select
        {...inputGeneralProps}
        value={filters.platform || ''}
        options={platformFilterOptionsWithAll}
        onChange={(value) => onFiltersChange({ ...filters, platform: value })}
        displayEmpty
        className={classes.platformCell}
      />
      <Select
        {...inputGeneralProps}
        value={filters.status || ''}
        options={statusFilterOptionsWithAll}
        onChange={(value) => onFiltersChange({ ...filters, status: value })}
        displayEmpty
      />
      <GridTableCell justify="end" className={classes.clearAllButtonCell}>
        <Button variant="outlined" size="small" onClick={onReset}>
          Clear All
        </Button>
      </GridTableCell>
    </GridTableRow>
  );
};

export { FiltersRow };
